import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/lib/api.ts'

export interface TanssDepartment {
  id: number
  name: string
  employeeIds: number[]
}

export interface PlanningAdditionalType {
  id: number
  name: string
  type: string
  active: boolean
  backgroundColor?: string
  fontColor?: string
}

export interface TanssEmployee {
  id: number
  name: string
  initials?: string | null
  active?: boolean
}

export function useCalendarDepartments() {
  return useQuery<TanssDepartment[]>({
    queryKey: ['dispo-filter-departments'],
    queryFn: async () => {
      const res = await apiClient.get<TanssDepartment[]>('/dispo/departments')
      return res.data
    },
    staleTime: 10 * 60 * 1000,
    retry: 1,
  })
}

export function useCalendarPlanningTypes() {
  return useQuery<PlanningAdditionalType[]>({
    queryKey: ['dispo-filter-planning-additional-types'],
    queryFn: async () => {
      const res = await apiClient.get<PlanningAdditionalType[]>('/dispo/planning-additional-types')
      return res.data
    },
    staleTime: 10 * 60 * 1000,
    retry: 1,
  })
}

export function useCalendarTanssEmployees() {
  return useQuery<TanssEmployee[]>({
    queryKey: ['dispo-filter-tanss-employees'],
    queryFn: async () => {
      const res = await apiClient.get<TanssEmployee[]>('/tickets/meta/tanss-employees')
      return res.data.filter((e) => e.active !== false)
    },
    staleTime: 10 * 60 * 1000,
    retry: 1,
  })
}
